import {App, Button, Flex, Upload} from "antd";
import {PiUploadSimpleBold} from "react-icons/pi";
import React, {useState} from "react";
import {getBaseUrl} from "../../../api/axiosInstance";
import {UploadChangeParam} from "antd/es/upload";
import {postRequest} from "../../../api/httpRequest";
import {filesStore} from "../../../store/store";

const UploadDoc: React.FC<{
    id?: string,
    disabled?: boolean,
    maxCount?: boolean,
    filesToDone?: string[],
    onFileChange: (file: UploadChangeParam, name: string | undefined) => void
}> = ({
          id,
          disabled,
          maxCount,
          filesToDone,
          onFileChange
      }) => {

    const [errorText, setErrorText] = useState<string>();
    const {files, setFiles} = filesStore();
    const {notification} = App.useApp()

    const uploadImage = async (options: any) => {
        const {onSuccess, onError, file} = options;

        if (!["jpg", "png", "jpeg", "zip", "pdf"].includes(file.name.split(".").pop())) {
            notification.error({
                message: "Недопустимый формат файла",
                description: "Допустимые форматы: jpg, png, jpeg, zip, pdf",
            });
            setErrorText("Допустимые форматы: jpg, png, jpeg, zip, pdf");
            return
        }

        const fmData = new FormData();
        const config = {
            headers: {"content-type": "multipart/form-data"},
        };
        fmData.append("file", file);
        fmData.append("destiny", id ? id : Math.random().toString());
        fmData.append("name", file.name);
        fmData.append("extension", file.name.split(".").pop());

        postRequest(
            `${getBaseUrl()}/server/proxy/contracts/uploadFile`,
            fmData,
            config
        ).then(response => {
            setErrorText(undefined);
            onSuccess("Ok");
            if (id !== undefined) {
                setFiles({...files, [id]: id});
            }
        })
            .catch((err: unknown) => {
                const axErr = err as { response?: { status?: number } };
                if (axErr.response?.status === 413) {
                    setErrorText("Превышен максимальный размер файла (5МБ)");
                }
                onError({ err });
            });
    };

    return (
        <Flex align={"center"} gap={"16px"}>
            <Upload
                maxCount={maxCount ? undefined : 1}
                accept={".jpg,.png,.jpeg,.zip,.pdf"}
                withCredentials={true}
                customRequest={uploadImage}
                onChange={(event) => onFileChange(event, id)}
            >
                <Button disabled={disabled} icon={<PiUploadSimpleBold/>}>Загрузить</Button>
            </Upload>
            {errorText && <div style={{color: "#f5222d"}}>{errorText}</div>}
        </Flex>
    )
}

export default UploadDoc